/* ===== Подключение стилей ===== */
import s from "./Reliable.module.scss";


function Reliable() {
    return (
        <section className={s.reliable}>
            <div className={`container ${s.container}`}>
                <div className={s.content}>
                    <h3 className={s.title}>Ваш надёжный топливный партнёр</h3>
                    <p>
                        ООО «Дизель Гарант» — надежный поставщик
                        дизельного топлива для малого и среднего бизнеса.
                        Мы осуществляем продажу и оперативную доставку
                        сертифицированного топлива Евро-5 по Москве
                        и Московской области, обеспечивая стабильность
                        снабжения, высокое качество и гибкие
                        условия сотрудничества.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Reliable;